import React from 'react';
import styles from './styles/Card.module.css';

export default function Card({
    children,
    className = '',
    hover = false,
    onClick,
    ...props
}) {
    return (
        <div
            className={`${styles.card} ${hover ? styles.hover : ''} ${className}`}
            onClick={onClick}
            {...props}
        >
            {children}
        </div>
    );
}
